import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Image } from 'lucide';
import { NbIcon } from '../../icon/icon';

/**
 * `<nb-image-placeholder>` — the diagonal-striped image placeholder box
 * (Mockup `.imgph`).
 *
 * Renders a flex box filled with a 135deg repeating-linear-gradient of the
 * `--imgph-a` / `--imgph-b` stripes, centring a faint `Image` `<nb-icon>`
 * (28px). Purely decorative — the host carries `aria-hidden="true"` so assistive
 * technology skips it. Set `height` to any CSS length (default `128px`).
 *
 * @example
 * <nb-image-placeholder />
 * <nb-image-placeholder height="200px" />
 */
@Component({
  selector: 'nb-image-placeholder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbIcon],
  host: {
    'aria-hidden': 'true',
    '[style.--nb-imgph-height]': 'height()',
  },
  template: `<nb-icon [icon]="Image" />`,
  styleUrl: './image-placeholder.css',
})
export class NbImagePlaceholder {
  /** Height of the placeholder box as any CSS length. */
  readonly height = input<string>('128px');

  protected readonly Image = Image;
}
